import { EventEmitter } from 'events';
import { StylingProvider, ThemeProperties, TextStyles, StylingProviderEvents } from '@fluidx/office-fluid-types';

/**
 * Default implementation of the @StylingProvider interface to be used by hosts.
 */
export class AppStylingProvider extends EventEmitter implements StylingProvider {
  /** A map of property /values describing the current application defined theme */
  protected appThemeProperties: ThemeProperties;

  /** A map of text style name to it's corresponding collection of property names and values */
  private appTextStyles: TextStyles;

  constructor() {
    super();
    this.setMaxListeners(0);
  }

  public get StylingProvider() {
    return this;
  }

  public get themeProperties(): ThemeProperties {
    return this.appThemeProperties;
  }

  public get textStyles(): TextStyles {
    return this.appTextStyles;
  }

  /* Will fire 'themePropertiesChanged' on change of themeProperties */
  public setThemeProperties(properties: ThemeProperties): void {
    const previousThemeProperties = this.appThemeProperties ? new Map(this.appThemeProperties) : undefined;
    this.appThemeProperties = properties;
    this.emit(StylingProviderEvents.themePropertiesChanged, previousThemeProperties);
  }

  /* Will fire 'textStylesChanged' on change of textStyles */
  public setTextStyles(styles: TextStyles): void {
    const previousStyles = this.appTextStyles ? new Map(this.appTextStyles) : undefined;
    this.appTextStyles = styles;
    this.emit(StylingProviderEvents.textStylesChanged, previousStyles);
  }
}
